import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TreeView from '@material-ui/lab/TreeView';
import TreeItem from '@material-ui/lab/TreeItem';
import Typography from '@material-ui/core/Typography';
import { lighten } from '@material-ui/core/styles/colorManipulator';

import StorageIcon from '@material-ui/icons/Storage';
import FolderIcon from '@material-ui/icons/Folder';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';

import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';

import useApp from 'app/context/useApp';

const useTreeItemStyles = makeStyles((theme) => ({
    root: {
        color: theme.palette.text.secondary,

        '&$selected > $content': {
            backgroundColor: `var(--tree-view-bg-color, ${lighten(theme.palette.primary.main, 0.85)})`,
            color: 'var(--tree-view-color)',
        },
        '&$selected > $content $label': {
            backgroundColor: 'transparent !important',
        },
        '&:focus > $content $label, &:hover > $content $label': {
            backgroundColor: 'transparent !important',
        },
    },
    content: {
        color: theme.palette.text.secondary,
        borderTopRightRadius: theme.shape.borderRadius * 2,
        borderBottomRightRadius: theme.shape.borderRadius * 2,
        paddingRight: theme.spacing(1),
        paddingLeft: 'var(--padding-left)',
        fontWeight: theme.typography.fontWeightMedium,
        userSelect: 'none',

        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        },
        '&:focus': {
            backgroundColor: `var(--tree-view-bg-color, ${lighten(theme.palette.primary.main, 0.85)})`,
            color: 'var(--tree-view-color)',
        },
    },
    group: {
        marginLeft: 0
    },
    expanded: {},
    selected: {

    },
    label: {
        fontWeight: 'inherit',
        color: 'inherit',
    },
    labelRoot: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(1, 0),
    },
    labelIcon: {
        marginRight: theme.spacing(1),
    },
    labelText: {
        fontWeight: 'inherit',
        flexGrow: 1,
    },
}));

function StyledTreeItem(props) {
    const classes = useTreeItemStyles();
    const { folder, selected, color, bgColor, onSelect, onToggle, level, ...other } = props;
    console.log()
    return (
        <TreeItem
            nodeId={folder.id.toString()}
            label={
                <div className={classes.labelRoot} onClick={() => onSelect(folder.id)} onDoubleClick={() => onToggle(folder.id.toString())}>
                    {(folder.id === 0) ? (
                        <StorageIcon color="inherit" className={classes.labelIcon} />
                    ) : (folder.id === selected) ? (
                        <FolderOpenIcon color="inherit" className={classes.labelIcon} />
                    ) : (
                        <FolderIcon color="inherit" className={classes.labelIcon} />
                    )}
                    <Typography variant="body2" className={classes.labelText}>
                        {folder.name}
                    </Typography>
                </div>
            }
            style={{
                '--tree-view-color': color,
                '--tree-view-bg-color': bgColor,
                '--padding-left': (8 * level) + 'px'
            }}
            classes={{
                root: classes.root,
                content: classes.content,
                expanded: classes.expanded,
                selected: classes.selected,
                group: classes.group,
                label: classes.label,
            }}
            onIconClick={() => onToggle(folder.id.toString())}
            {...other}
            >
            {(folder.folders_recursive && (folder.folders_recursive.length > 0)) && folder.folders_recursive.map(child => (
                <StyledTreeItem key={child.id} folder={child} selected={selected} onSelect={onSelect} onToggle={onToggle} level={level + 2}/>
            ))}
        </TreeItem>
    );
}

const useStyles = makeStyles({
    root: {
        height: 264,
        flexGrow: 1,
        maxWidth: 400,
    },
});

export default function DriveTreeView(props) {
    const classes = useStyles();
    const { app } = useApp();

    const { folders, selected, onSelect } = props;

    const [ expanded, setExpanded ] = useState(['0']);

    const level = 1;

    useEffect(() => {

        const ss = selected.toString();
        if (expanded.indexOf(ss) === -1) setExpanded([...expanded, ss]);

    }, [selected]);

    const handleToggle = nodeId => {
        const newExpanded = [...expanded];
        const i = newExpanded.indexOf(nodeId);

        if (i === -1) {
            newExpanded.push(nodeId);
        } else {
            newExpanded.splice(i,1);
        }

        setExpanded(newExpanded);
      };

    const handleSelect = id => {
        onSelect(id);
    }

    return (
        <TreeView
            className={classes.root}
            defaultExpanded={['0', selected.toString()]}
            defaultCollapseIcon={<ArrowDropDownIcon />}
            defaultExpandIcon={<ArrowRightIcon />}
            defaultEndIcon={<div style={{ width: 24 }} />}
            selected={selected.toString()}
            expanded={expanded}
            >
            <StyledTreeItem
                selected={selected}
                folder={{id: 0, name: app.club.name, folders_recursive: folders}}
                onToggle={handleToggle}
                onSelect={handleSelect}
                level={level}
            />
        </TreeView>
    );
}
